import { useState, useEffect } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { closeIcon } from "./svgs";
import api from "../../api/api";
import ToastMessage from "../../utils/mui/righttoptoast";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../reduxtoolkit/toastslice";

const AssignRoomModal = ({
  open,
  selectedCard,
  onClose,

  setRoomModalOpen,
  setFetchedData,
  currentRoom,
  alldata = [],
}) => {
  const [selected, setSelected] = useState(currentRoom || "");
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const practiseid = window.getPracticeId();
  const [alertmessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [toastopen, setOpen] = useState(false);
  const [occupiedPatient, setOccupiedPatient] = useState(null);
// Seed from alldata so yellow tags render instantly — API call updates it later
const [occupiedList, setOccupiedList] = useState(() =>
  (Array.isArray(alldata) ? alldata : []).filter(
    (p) => p && p.room_no && String(p.room_no).trim() !== ""
  )
);
const [confirmReassign, setConfirmReassign] = useState(null); // { room, occupant }
  const reduxDate = useSelector((state) => state.filter.currentDate);
const [currentPatientRoom, setCurrentPatientRoom] = useState(null);
const dispatch=useDispatch()

  const handlealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const fetchRooms = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/v1/${practiseid}/rooms/get`);
      if (response.status === 200) {
        setRooms(response.data || []);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

 useEffect(() => {
  if (open) {
    fetchRooms();
    fetchOccupied();
    // Re-seed from alldata in case it changed since mount
    setOccupiedList(
      (Array.isArray(alldata) ? alldata : []).filter(
        (p) => p && p.room_no && String(p.room_no).trim() !== ""
      )
    );
  }
}, [open]);
useEffect(() => {
  if (selectedCard?.room_no) {
    setCurrentPatientRoom({
      patientid: selectedCard.patientid,
      appointmentid: selectedCard.appointmentid,
      token: selectedCard.token,
      room_no: selectedCard.room_no,
      id: selectedCard.id,
    });

    setSelected(selectedCard.room_no);
  } else {
    setCurrentPatientRoom(null);
  }
}, [selectedCard]);

  if (!open) return null;

  // Group rooms by type
  const groupedRooms = rooms.reduce((acc, room) => {
    if (!acc[room.type]) acc[room.type] = [];
    acc[room.type].push(room);
    return acc;
  }, {});

const fetchOccupied = async () => {
  try {
    const res = await api.post(`/v1/${practiseid}/checkin/future/get`, {
      stdate: reduxDate,
      eddate: reduxDate,
    });

    if (res.status === 200) {
      setOccupiedList(res.data || []);
    }
  } catch (e) {
    console.log(e);
  }
};

const assignroom = async (overrideRoom, overrideOccupant) => {
  const targetRoom = overrideRoom !== undefined ? overrideRoom : selected;
  const targetOccupant =
    overrideOccupant !== undefined ? overrideOccupant : occupiedPatient;

  if (!targetRoom) return;

  try {
    setIsLoading(true);

    // 🔴 If room occupied → unassign first
    if (targetOccupant) {
      await unassignPatient(targetOccupant);
    }

    const payload = {
      appointment_id: selectedCard?.appointmentid,
      appointment_date: dayjs(selectedCard?.startDate).format("YYYY-MM-DD"),
      room_no: targetRoom,
      visit_confirmation: "Ready for Provider",
    };

    if (selectedCard.linked_provider) {
      payload.linked_provider = selectedCard.linked_provider;
    }

    const response = await api.put(
      `/v1/${practiseid}/checkin/patient/${selectedCard?.patientid}/update-data`,
      payload
    );

    if (response.status === 200) {

    ;
dispatch(
          showToast({
            message: "Room Assigned Successfully",
            severity: "success",
          })
        );
      // update table UI — current patient gets the room,
      // and the displaced occupant (if any) gets cleared in the same pass
      setFetchedData((prev) =>
        prev.map((item) => {
          if (item.id === selectedCard.id) {
            return { ...item, room_no: targetRoom };
          }
          if (
            targetOccupant &&
            String(item.patientid) === String(targetOccupant.patientid)
          ) {
            return { ...item, room_no: "" };
          }
          return item;
        })
      );

      // 🔥 refresh occupied list
      await fetchOccupied();

      
        setOpen(false);
        setRoomModalOpen(false);
    
    }
  } catch (error) {
    console.log(error);
    setAlertMessage("Something Went Wrong");
    setSeverity("error");
    setOpen(true);
  } finally {
    setIsLoading(false);
  }
};
const unassignCurrentPatientRoom = async () => {
  if (!selectedCard?.room_no) return;

  try {
    setIsLoading(true);

    const res = await api.post(
      `/v1/${practiseid}/checkin/patient/${selectedCard.patientid}/unassign`,
      {
        appointment_id: selectedCard.appointmentid,
        token: selectedCard.token,
        roomno: selectedCard.room_no,
        rowid: selectedCard.id,
      }
    );

    if (res.status === 200) {
      setAlertMessage("Room Unassigned Successfully");
      setSeverity("success");
      setOpen(true);
dispatch(
          showToast({
            message: "Room Unassigned Successfully",
            severity: "success",
          })
        );
      // update UI table
      setFetchedData((prev) =>
        prev.map((item) =>
          item.id === selectedCard.id
            ? { ...item, room_no: "" }
            : item
        )
      );

      await fetchOccupied()
        setRoomModalOpen(false);
        setOpen(false);
      
    }
  } catch (error) {
    console.log(error);
    setAlertMessage("Unassign failed");
    setSeverity("error");
    setOpen(true);
  } finally {
    setIsLoading(false);
  }
};

const getOccupantName = (occupant) =>
  [occupant?.firstname, occupant?.lastname]
    .filter(Boolean)
    .join(" ")
    .trim() || "Another patient";

const handleRoomClick = (roomName) => {
  const occupied = occupiedList.find(
    (item) =>
      item.room_no === roomName &&
      String(item.patientid) !== String(selectedCard?.patientid)
  );

  if (occupied) {
    // Ask the user to confirm before reassigning
    setConfirmReassign({ room: roomName, occupant: occupied });
    return;
  }

  setSelected(roomName);
  setOccupiedPatient(null);
};

const handleConfirmReassign = async () => {
  if (!confirmReassign) return;
  const { room, occupant } = confirmReassign;
  setSelected(room);
  setOccupiedPatient(occupant);
  setConfirmReassign(null);
  // Pass values directly — don't rely on state (which hasn't flushed yet)
  await assignroom(room, occupant);
};

const unassignPatient = async (patient) => {
  try {
    await api.post(
      `/v1/${practiseid}/checkin/patient/${patient.patientid}/unassign`,
      {
        appointment_id: patient.appointmentid,
        token: patient.token,
        roomno: patient.room_no,
        rowid: patient.id,
      }
    );
  } catch (error) {
    console.log("Unassign error", error);
  }
};


  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/30"
        onClick={onClose}
        aria-hidden
      />
      <div className="relative z-10 w-[460px] max-w-[95vw] rounded-2xl bg-white shadow-2xl">
        <div className="flex items-center mt-3 justify-between border-b px-6 py-2">
          <span className="text-[18px] font-medium text-[#1D2951] font-inter">
            Assign Rooms
          </span>
          <button onClick={onClose} className="h-4 w-4" aria-label="Close">
            {closeIcon}
          </button>
        </div>
{/* {occupiedPatient && (
  <div className="mb-4 p-3 rounded-lg bg-orange-50 text-orange-700 text-sm font-semibold">
    {occupiedPatient.room_no} is currently being used by{" "}
    {occupiedPatient.firstname} {occupiedPatient.lastname}.  
   
  </div>
)} */}


        <div className="px-6 py-6">
          {loading ? (
            <div className="flex justify-center items-center h-[200px]">
              <CircularProgress />
            </div>
          ) : (
<div className="grid grid-cols-2 gap-x-10 gap-y-8 max-h-[400px] overflow-y-auto pr-2">

              {Object.entries(groupedRooms).map(([type, typeRooms]) => (
                <div
                  key={type}
                  className="flex flex-col justify-start items-start"
                >
                  <div className="mb-4 font-inter text-[16px] text-[#0F2344] font-semibold">
                    {type}
                  </div>
                  <div className="flex flex-wrap gap-4 p-2">
                    {typeRooms.map((r) => {
                      const active = selected === r.room;
                      const occupant =
                        String(r.room).toLowerCase() !== "waiting room"
                          ? occupiedList.find(
                              (item) =>
                                item.room_no === r.room &&
                                String(item.patientid) !==
                                  String(selectedCard?.patientid)
                            )
                          : null;
                      const isOccupied = !!occupant;
                      return (
                        <button
                          key={r.id}
                          onClick={() => handleRoomClick(r.room)}
                          title={
                            isOccupied
                              ? `${r.room} is currently being used by ${getOccupantName(
                                  occupant
                                )}`
                              : ""
                          }
                          className={[
                            "px-4 py-2 rounded-full text-[14px] shadow-md shadow-[#00000040] font-inter transition-all",
                            isOccupied
                              ? "bg-[#FEF3C7] text-[#92400E] border border-[#F59E0B]"
                              : active
                                ? "bg-[#E17954] text-white"
                                : "bg-[#F3F3F3] text-[#0F2344]",
                          ].join(" ")}
                        >
                          {r.room}
                        </button>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          )}
    <div
  className={`mt-4 flex ${
    selectedCard?.room_no
      ? "justify-center gap-4"
      : "justify-center"
  }`}
>
  {/* Assign button */}
  <button
    onClick={() => assignroom()}
    disabled={!selected}
    className={`h-[38px] ${
      selectedCard?.room_no ? "w-[180px]" : "w-[220px]"
    } rounded-full text-[14px] font-medium text-white font-inter
    ${
      !selected
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-[#50869A]"
    }`}
  >
    Re-Assign Room
  </button>

  {/* Unassign button */}
  {selectedCard?.room_no && (
    <button
      onClick={unassignCurrentPatientRoom}
      className="h-[38px] w-[180px] rounded-full bg-red-500 text-white text-sm font-medium"
    >
      Unassign Room
    </button>
  )}
</div>
 

        </div>
      </div>
      {confirmReassign && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/40"
            onClick={() => setConfirmReassign(null)}
            aria-hidden
          />
          <div className="relative z-10 w-[420px] max-w-[92vw] rounded-2xl bg-white shadow-2xl p-6">
            <div className="flex flex-col items-center text-center gap-3">
              <div className="w-12 h-12 rounded-full bg-[#FEF3C7] flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#B45309"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                  <line x1="12" y1="9" x2="12" y2="13" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
              </div>
              <div className="text-[16px] font-semibold font-inter text-[#1D2951]">
                Room Already Assigned
              </div>
              <div className="text-[14px] font-inter text-[#4B5563]">
                <span className="font-semibold">{confirmReassign.room}</span>{" "}
                is currently being used by{" "}
                <span className="font-semibold">
                  {getOccupantName(confirmReassign.occupant)}
                </span>
                .
                <br />
                Do you want to reassign it?{" "}
                <span className="font-semibold">
                  {getOccupantName(confirmReassign.occupant)}
                </span>{" "}
                will be unassigned first.
              </div>
              <div className="flex items-center justify-center gap-3 mt-2 w-full">
                <button
                  onClick={() => setConfirmReassign(null)}
                  className="h-[38px] flex-1 rounded-full border border-[#D1D5DB] text-[14px] font-medium text-[#374151] bg-white font-inter"
                >
                  Cancel
                </button>
                <button
                  onClick={handleConfirmReassign}
                  className="h-[38px] flex-1 rounded-full bg-[#E17954] text-[14px] font-medium text-white font-inter"
                >
                  Reassign
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.7)", // reduced opacity (default is 0.5)
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastMessage
        message={alertmessage}
        severity={severity}
        open={toastopen}
        handleClose={handlealert}
      />
    </div>
  );
};

export default AssignRoomModal;
